export enum LacertaRoutePaths {
  home = 'home',
  pageNotFound = '404',
  disclaimer = 'disclaimer',
  privacy = 'privacyverklaring',
  cookies = 'cookies',
}
